import _styled from "@emotion/styled/base";
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { forwardRef } from 'react';
import { Container } from '../../../primitives/Button/components/Container.js';
import { Content } from '../../../primitives/Button/components/Content.js';
import { LoadingAnimation } from '../../../primitives/Button/components/LoadingAnimation.js';
const BaseComponent = forwardRef(function InnerBaseComponent({
  icon,
  iconPosition,
  loading,
  children,
  size,
  ...restProps
}, ref) {
  const theme = useTheme();
  const getContent = () => {
    return _jsxs(_Fragment, {
      children: [icon && iconPosition === 'left' && icon, children, icon && iconPosition === 'right' && icon]
    });
  };
  return _jsx(Container, {
    size: size,
    ...restProps,
    ref: ref,
    children: loading ? _jsxs(_Fragment, {
      children: [_jsx(Content, {
        children: getContent()
      }), _jsx(LoadingAnimation, {
        size: size === 'small' ? 10 : undefined
      })]
    }) : getContent()
  });
});
export const Base = /*#__PURE__*/_styled(BaseComponent, process.env.NODE_ENV === "production" ? {
  target: "ei2s9ll0"
} : {
  target: "ei2s9ll0",
  label: "Base"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhc2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYzBDIiwiZmlsZSI6IkJhc2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBGcmFnbWVudCBhcyBfRnJhZ21lbnQsIGpzeHMgYXMgX2pzeHMsIGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgeyB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL0J1dHRvbi9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBDb250ZW50IH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9CdXR0b24vY29tcG9uZW50cy9Db250ZW50LmpzJztcbmltcG9ydCB7IExvYWRpbmdBbmltYXRpb24gfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL0J1dHRvbi9jb21wb25lbnRzL0xvYWRpbmdBbmltYXRpb24uanMnO1xuY29uc3QgQmFzZUNvbXBvbmVudCA9IGZvcndhcmRSZWYoZnVuY3Rpb24gSW5uZXJCYXNlQ29tcG9uZW50KHsgaWNvbiwgaWNvblBvc2l0aW9uLCBsb2FkaW5nLCBjaGlsZHJlbiwgc2l6ZSwgLi4ucmVzdFByb3BzIH0sIHJlZikge1xuICAgIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcbiAgICBjb25zdCBnZXRDb250ZW50ID0gKCkgPT4ge1xuICAgICAgICByZXR1cm4gKF9qc3hzKF9GcmFnbWVudCwgeyBjaGlsZHJlbjogW2ljb24gJiYgaWNvblBvc2l0aW9uID09PSAnbGVmdCcgJiYgaWNvbiwgY2hpbGRyZW4sIGljb24gJiYgaWNvblBvc2l0aW9uID09PSAncmlnaHQnICYmIGljb25dIH0pKTtcbiAgICB9O1xuICAgIHJldHVybiAoX2pzeChDb250YWluZXIsIHsgc2l6ZTogc2l6ZSwgLi4ucmVzdFByb3BzLCByZWY6IHJlZiwgY2hpbGRyZW46IGxvYWRpbmcgPyAoX2pzeHMoX0ZyYWdtZW50LCB7IGNoaWxkcmVuOiBbX2pzeChDb250ZW50LCB7IGNoaWxkcmVuOiBnZXRDb250ZW50KCkgfSksIF9qc3goTG9hZGluZ0FuaW1hdGlvbiwgeyBzaXplOiBzaXplID09PSAnc21hbGwnID8gMTAgOiB1bmRlZmluZWQgfSldIH0pKSA6IChnZXRDb250ZW50KCkpIH0pKTtcbn0pO1xuZXhwb3J0IGNvbnN0IEJhc2UgPSBzdHlsZWQoQmFzZUNvbXBvbmVudCkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1CYXNlLmpzLm1hcCJdfQ== */");